import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useUpdatePropertyMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ propertyId: e, ...t }) => r.updateProperty(e, t),
		onSuccess: (t, { propertyId: n }) => {
			i.invalidateQueries({ queryKey: e.property(n) }), i.invalidateQueries({ queryKey: e.publicProperty(n) }), i.invalidateQueries({ queryKey: e.hostFeed() }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useUpdatePropertyMutation };
